/* New Well — Ürün yorumları: daha fazla yükleme ve yorum gönderme */
(() => {
  if (window.__nwYorum) return;
  window.__nwYorum = true;

  const kacis = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const tarih = (t) => {
    const d = new Date(t);
    return isNaN(d) ? '' : d.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  function yorumHTML(y) {
    return `<li class="nw-yorum">
      <div class="nw-yorum__ust">
        <span class="nw-yildizlar" style="--nw-dolu:${y.puan * 20}%" role="img" aria-label="5 üzerinden ${y.puan}"></span>
        <strong>${kacis(y.ad)}</strong>
        ${y.dogrulanmis ? '<span class="nw-yorum__rozet">✓ Doğrulanmış alıcı</span>' : ''}
        <time datetime="${kacis(y.tarih)}">${tarih(y.tarih)}</time>
      </div>
      ${y.baslik ? `<h3 class="nw-yorum__baslik">${kacis(y.baslik)}</h3>` : ''}
      <p class="nw-yorum__metin">${kacis(y.metin).replace(/\n/g, '<br>')}</p>
      ${y.yanit ? `<div class="nw-yorum__yanit"><strong>New Well</strong><p>${kacis(y.yanit).replace(/\n/g, '<br>')}</p></div>` : ''}
    </li>`;
  }

  let turnstileYuklendi = null;
  function turnstileYukle() {
    if (!turnstileYuklendi) {
      turnstileYuklendi = new Promise((tamam, hata) => {
        const s = document.createElement('script');
        s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        s.async = true;
        s.onload = tamam;
        s.onerror = hata;
        document.head.appendChild(s);
      });
    }
    return turnstileYuklendi;
  }

  function kur(kok) {
    const servis = (kok.dataset.servis || '').replace(/\/$/, '');
    const urun = kok.dataset.urun;
    const form = kok.querySelector('[data-nw-form]');
    const liste = kok.querySelector('[data-nw-liste]');
    const mesaj = kok.querySelector('[data-nw-mesaj]');
    const tsKutu = kok.querySelector('[data-nw-turnstile]');
    const anahtar = kok.dataset.turnstile;
    let sayfa = 1;
    let tsId = null;
    // Yorum isteği e-postasındaki imzalı kod (doğrulanmış alıcı rozeti için)
    const dogrulamaKodu = new URLSearchParams(location.search).get('nwd') || '';

    const formAc = async () => {
      form.hidden = false;
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (anahtar && tsId === null) {
        try {
          await turnstileYukle();
          tsId = window.turnstile.render(tsKutu, { sitekey: anahtar, language: 'tr', size: 'flexible', theme: 'light' });
        } catch (e) {
          mesaj.textContent = 'Güvenlik doğrulaması yüklenemedi. Sayfayı yenileyip tekrar deneyin.';
        }
      }
    };

    kok.querySelector('[data-nw-yorum-ac]')?.addEventListener('click', formAc);
    kok.querySelector('[data-nw-yorum-kapat]')?.addEventListener('click', () => (form.hidden = true));
    document.querySelectorAll('[data-nw-yorum-yaz]').forEach((a) =>
      a.addEventListener('click', (e) => {
        e.preventDefault();
        formAc();
      })
    );

    // E-postadaki "Yorum yaz" bağlantısı (#nw-yorum-yaz) formu doğrudan açar
    if (location.hash === '#nw-yorum-yaz') setTimeout(formAc, 300);

    const daha = kok.querySelector('[data-nw-daha]');
    daha?.addEventListener('click', async () => {
      if (!servis) return;
      daha.disabled = true;
      try {
        const r = await fetch(`${servis}/api/yorumlar?urun=${encodeURIComponent(urun)}&sayfa=${sayfa + 1}`);
        const j = await r.json();
        sayfa = j.sayfa;
        liste.insertAdjacentHTML('beforeend', j.yorumlar.map(yorumHTML).join(''));
        if (!j.sonraki) daha.remove();
        else daha.disabled = false;
      } catch (e) {
        daha.disabled = false;
      }
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const veri = Object.fromEntries(new FormData(form));
      mesaj.className = 'nw-form__mesaj';
      if (!veri.puan) return (mesaj.textContent = 'Lütfen yıldızlardan birini seçin.');
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      if (!servis) return (mesaj.textContent = 'Yorum servisi henüz ayarlanmadı.');
      if (anahtar) {
        veri.dogrulama = tsId !== null ? window.turnstile.getResponse(tsId) : '';
        if (!veri.dogrulama) return (mesaj.textContent = 'Lütfen güvenlik doğrulamasının tamamlanmasını bekleyin.');
      }
      const dugme = form.querySelector('[type=submit]');
      dugme.disabled = true;
      mesaj.textContent = 'Gönderiliyor…';
      try {
        const r = await fetch(`${servis}/api/yorum`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ...veri, urun, kod: dogrulamaKodu }),
        });
        const j = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(j.hata || 'Gönderilemedi. Lütfen tekrar deneyin.');
        form.reset();
        form.querySelectorAll('input, textarea, button[type=submit]').forEach((x) => (x.disabled = true));
        mesaj.className = 'nw-form__mesaj is-tamam';
        mesaj.textContent = 'Teşekkürler! Yorumunuz kontrol edildikten sonra yayınlanacak.';
      } catch (err) {
        mesaj.className = 'nw-form__mesaj is-hata';
        mesaj.textContent = err.message;
        dugme.disabled = false;
        if (tsId !== null) window.turnstile.reset(tsId);
      }
    });
  }

  const basla = () => document.querySelectorAll('[data-nw-yorumlar]').forEach(kur);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla);
  else basla();
})();
